module.exports = __webpack_public_path__ + "63976bce6db8302a56306cdc043d6ca3.svg";